import * as React from 'react';

const productUpdatesIconSmall = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="4" fill="white" />
    <rect
      x="2"
      y="1"
      width="16"
      height="8"
      rx="1"
      fill="url(#paint0_linear_25216_13934)"
    />
    <rect
      x="2"
      y="10"
      width="16"
      height="8"
      rx="1"
      fill="url(#paint1_linear_25216_13934)"
    />
    <g clip-path="url(#clip0_25216_13934)">
      <path
        d="M7.25 2.83522C7.62707 3.05293 7.94074 3.36535 8.15995 3.74154C8.37917 4.11774 8.49634 4.54466 8.49986 4.98005C8.50337 5.41544 8.39312 5.84421 8.18001 6.22389C7.96689 6.60358 7.65831 6.92102 7.28481 7.1448C6.91131 7.36857 6.48584 7.49092 6.05052 7.49973C5.61521 7.50854 5.18514 7.40351 4.80289 7.19503C4.42064 6.98655 4.09947 6.68185 3.87117 6.3111C3.64287 5.94034 3.51535 5.5164 3.50125 5.08122L3.5 5.00022L3.50125 4.91922C3.51525 4.48746 3.64089 4.06671 3.86591 3.69797C4.09093 3.32922 4.40766 3.02508 4.78522 2.81519C5.16278 2.6053 5.58829 2.49682 6.02025 2.50033C6.45222 2.50384 6.8759 2.61922 7.25 2.83522ZM6.92675 4.32347C6.8837 4.28042 6.82643 4.25457 6.76567 4.25075C6.70491 4.24692 6.64485 4.2654 6.59675 4.30272L6.57325 4.32347L5.75 5.14647L5.42675 4.82347L5.40325 4.80272C5.35515 4.76543 5.29509 4.74697 5.23435 4.75081C5.17361 4.75464 5.11635 4.7805 5.07332 4.82353C5.03028 4.86657 5.00442 4.92383 5.00059 4.98457C4.99676 5.04531 5.01521 5.10536 5.0525 5.15347L5.07325 5.17697L5.57325 5.67697L5.59675 5.69772C5.64059 5.73173 5.69451 5.7502 5.75 5.7502C5.80549 5.7502 5.85941 5.73173 5.90325 5.69772L5.92675 5.67697L6.92675 4.67697L6.9475 4.65347C6.98481 4.60537 7.00329 4.5453 6.99947 4.48455C6.99565 4.42379 6.96979 4.36652 6.92675 4.32347Z"
        fill="white"
      />
    </g>
    <g clip-path="url(#clip1_25216_13934)">
      <path
        d="M7.25 11.8352C7.62707 12.0529 7.94074 12.3653 8.15995 12.7415C8.37917 13.1177 8.49634 13.5447 8.49986 13.9801C8.50337 14.4154 8.39312 14.8442 8.18001 15.2239C7.96689 15.6036 7.65831 15.921 7.28481 16.1448C6.91131 16.3686 6.48584 16.4909 6.05052 16.4997C5.61521 16.5085 5.18514 16.4035 4.80289 16.195C4.42064 15.9865 4.09947 15.6818 3.87117 15.3111C3.64287 14.9403 3.51535 14.5164 3.50125 14.0812L3.5 14.0002L3.50125 13.9192C3.51525 13.4875 3.64089 13.0667 3.86591 12.698C4.09093 12.3292 4.40766 12.0251 4.78522 11.8152C5.16278 11.6053 5.58829 11.4968 6.02025 11.5003C6.45222 11.5038 6.8759 11.6192 7.25 11.8352ZM6.92675 13.3235C6.8837 13.2804 6.82643 13.2546 6.76567 13.2507C6.70491 13.2469 6.64485 13.2654 6.59675 13.3027L6.57325 13.3235L5.75 14.1465L5.42675 13.8235L5.40325 13.8027C5.35515 13.7654 5.29509 13.747 5.23435 13.7508C5.17361 13.7546 5.11635 13.7805 5.07332 13.8235C5.03028 13.8666 5.00442 13.9238 5.00059 13.9846C4.99676 14.0453 5.01521 14.1054 5.0525 14.1535L5.07325 14.177L5.57325 14.677L5.59675 14.6977C5.64059 14.7317 5.69451 14.7502 5.75 14.7502C5.80549 14.7502 5.85941 14.7317 5.90325 14.6977L5.92675 14.677L6.92675 13.677L6.9475 13.6535C6.98481 13.6054 7.00329 13.5453 6.99947 13.4845C6.99565 13.4238 6.96979 13.3665 6.92675 13.3235Z"
        fill="url(#paint2_linear_25216_13934)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_25216_13934"
        x1="15.4815"
        y1="7.774"
        x2="1.50548"
        y2="-3.15231"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2744FF" />
        <stop offset="1" stop-color="#B9D5FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_25216_13934"
        x1="13.7647"
        y1="15.9048"
        x2="2.29664"
        y2="1.98686"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BDD1E7" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_25216_13934"
        x1="7.71291"
        y1="15.734"
        x2="1.60878"
        y2="13.3479"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2744FF" />
        <stop offset="1" stop-color="#B9D5FF" />
      </linearGradient>
      <clipPath id="clip0_25216_13934">
        <rect width="6" height="6" fill="white" transform="translate(3 2)" />
      </clipPath>
      <clipPath id="clip1_25216_13934">
        <rect width="6" height="6" fill="white" transform="translate(3 11)" />
      </clipPath>
    </defs>
  </svg>
);

export default productUpdatesIconSmall;
